export const environment = {
  local: true,
  production: false,
};

export const enum Protocol {
  http = 'http://',
  https = 'https://',
}

export const enum EntityPath {
  odata = 'odata.actuar.cloud',
  base = 'actuar-api.actuar.cloud',
  afig = 'afig-api.actuar.cloud',
  paguela = 'paguelacore-api.actuar.cloud',
  chat = 'chat-api.actuar.cloud',
  file_group = 'filegroup-api.actuar.cloud',
  workout_service = 'workoutservice-api.actuar.cloud',
  workout_view = 'workoutview-api.actuar.cloud',
  activity_service = 'activityservice-api.actuar.cloud',
  user_service = 'userservice-api.actuar.cloud',
  shortener = 'link.pague.la',
  post_service = 'postservice-api.actuar.cloud',
  account_service = 'accountservice-api.actuar.cloud',
  receivable_service = 'receivableservice-api.actuar.cloud',
  client_notification = 'clientnotification-api.actuar.cloud',
  acesso = 'acesso-api.actuar.cloud',
  graduation_service = 'graduationservice-api.actuar.cloud',
}

export const braspag = {
  providerMerchantId: 'c7f999ad-0ea4-4621-9fd6-6b3d475c5d70',
  providerOrgId: '1snn5n9w'
};

export const url = (
  protocol: Protocol,
  entityPath: EntityPath,
  restUrl?: any
) => `${protocol}${entityPath}${restUrl}`;

export const successCodesCheckout: string[] = ['4', '6', '0', '00', '000', '0000', '174'];
